import { render, staticRenderFns } from "./activity_list.vue?vue&type=template&id=5aa871b2&scoped=true"
import script from "./activity_list.vue?vue&type=script&lang=js"
export * from "./activity_list.vue?vue&type=script&lang=js"
import style0 from "./activity_list.vue?vue&type=style&index=0&id=5aa871b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa871b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa871b2')) {
      api.createRecord('5aa871b2', component.options)
    } else {
      api.reload('5aa871b2', component.options)
    }
    module.hot.accept("./activity_list.vue?vue&type=template&id=5aa871b2&scoped=true", function () {
      api.rerender('5aa871b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/inspection_center/form/activity_list.vue"
export default component.exports